/** PDF type and size limits for tax-exempt document uploads. */

export const MAX_TAX_FILE_MB = 25;
export const MAX_TAX_FILE_BYTES = MAX_TAX_FILE_MB * 1024 * 1024;
export const ACCEPTED_TAX_FILE_TYPE = "application/pdf";
export const SUPPORTED_TAX_FILE_LABEL = "PDF";

export const MAX_TAX_FILE_SIZE_HINT = `Maximum size: ${MAX_TAX_FILE_MB}MB`;
export const SUPPORTED_FORMAT_HINT = `Supported format: ${SUPPORTED_TAX_FILE_LABEL}`;
export const OVERSIZE_REASON = `File size exceeds the max limit of ${MAX_TAX_FILE_MB}MB.`;
export const WRONG_TYPE_REASON = `Only ${SUPPORTED_TAX_FILE_LABEL} files are supported.`;

export type TaxFileValidation = { ok: true } | { ok: false; reason: string };

/** Some drag-drop sources report an empty MIME type for a valid PDF; fall back to the extension. */
function isPdf(file: File): boolean {
  if (file.type === ACCEPTED_TAX_FILE_TYPE) return true;
  return file.type === "" && file.name.toLowerCase().endsWith(".pdf");
}

export function validateTaxFile(file: File): TaxFileValidation {
  if (!isPdf(file)) return { ok: false, reason: WRONG_TYPE_REASON };
  if (file.size > MAX_TAX_FILE_BYTES) return { ok: false, reason: OVERSIZE_REASON };
  return { ok: true };
}
